import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  KibSuperSelect,
  type KibSuperSelectOption,
} from '@chewy/kib-fields-new-react'
import classNames from 'classnames'
import * as R from 'ramda'
import type { Field } from '@pbt/pbt-ui-components'

import { getSchedulerIsLoading } from '~/store/reducers/scheduler'

import '@chewy/kib-fields-new-styles/dist/kib-fields-new.css'
import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import styles from './AppointmentSelect.module.scss'

const AppointmentSelect = ({
  appointments,
  appointmentField,
  patientName,
  className,
}: {
  appointmentField: Field
  appointments: KibSuperSelectOption[]
  className?: string
  patientName: string
}) => {
  const { t } = useTranslation('Common')
  const isLoadingAppointments = useSelector(getSchedulerIsLoading)

  const noAppointments = R.isEmpty(appointments)

  const loadingPlaceholder = t('Common:LINK_TO_APPOINTMENT_PLACEHOLDER')

  const loadedPlaceholder = noAppointments
    ? t('Common:PATIENT_HAS_NO_APPOINTMENTS', { patientName })
    : t('Common:LINK_TO_APPOINTMENT_PLACEHOLDER')

  const placeholder = isLoadingAppointments
    ? loadingPlaceholder
    : loadedPlaceholder

  return (
    <KibSuperSelect
      className={classNames(styles.appointmentSelector, className)}
      disabled={isLoadingAppointments || noAppointments}
      label={t('Common:LINK_TO_APPOINTMENT')}
      loading={isLoadingAppointments}
      options={appointments}
      placeholder={placeholder}
      value={appointmentField.value}
      onChange={(selected) => {
        appointmentField.setValue(selected)
      }}
    />
  )
}

export default AppointmentSelect
